import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import { useDispatch, useSelector } from 'react-redux';
import { Get_Commission_Data_For_Selected_Lead_Action } from '../Redux/Actions/Commission_Action';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import CardActions from '@mui/material/CardActions';
import Grid from '@mui/material/Grid';
import { Button, TextField, useTheme } from '@mui/material';
import EventNoteIcon from '@mui/icons-material/EventNote';
import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import AddIcon from '@mui/icons-material/Add';
import { Add_Commission_Schedual_Data_Action } from '../Redux/Actions/Commission_Schedual_Dates_Actions';
import { Notify } from '../Utility/Notify';
export const CommissionSchedualpage = () => {
  const theme = useTheme();
  const mode = theme.palette.mode; // جلب الوضع ال

  const { id } = useParams();
  const dispatch = useDispatch();

  const [showDatePicker, setShowDatePicker] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [moneyofpayment, setmoneyofpayment] = useState();
  const [CommentVAlue, setCommentVAlue] = useState(null);

  const onpaymentmoneyvaluechange = (e) => {
    setmoneyofpayment(e.target.value);
  };

  const OnCommentChange = (e) => {
    setCommentVAlue(e.target.value);
  };

  useEffect(() => {
    const getdataforselectedlead = async () => {
      await dispatch(Get_Commission_Data_For_Selected_Lead_Action(id));
    };
    getdataforselectedlead();
  }, [dispatch, id]);

  const resselectedcommission = useSelector((state) => state.AllCommissions.Add_Commission);
  let AllData_Array = Array.isArray(resselectedcommission?.data) ? resselectedcommission.data : [];

  const leadData = AllData_Array?.[0];

  const handleDateChange = (date) => {
    if (date && date.toDate) {
      const jsDate = date.toDate();
      jsDate.setHours(12, 0, 0, 0); // يظبط الوقت عشان يتفادى فرق التوقيت
      setSelectedDate(jsDate);
      // console.log("📅 Selected DateTime:", jsDate);
    } else if (date instanceof Date) {
      date.setHours(12, 0, 0, 0);
      setSelectedDate(date);
      // console.log("📅 Selected DateTime:", date);
    }
  };

  const [loading, setloading] = useState(true);

  const AddNewPaymentdate = async () => {
    // Check if required values are missing
    if (!selectedDate) {
      Notify('error', '❌ Please Choose Date', 'error');
      return;
    }

    if (!moneyofpayment) {
      Notify('error', '❌ Please Put The Money Of Payment', 'error');
      return;
    }

    if (!leadData?.lead?._id) {
      Notify(
        'error',
        '❌ You Dont Choose A Lead Have A Commission You Must Sure From Commission Added Before This Process',
        'error',
      );
      return;
    }

    if (!leadData?._id) {
      Notify('error', 'There is No Commissions Added Before For This Process', 'error');
      return;
    }

    // If all good, continue
    setloading(true);

    await dispatch(
      Add_Commission_Schedual_Data_Action({
        lead: leadData.lead._id,
        Date: selectedDate,
        MoneyPayment: moneyofpayment,
        commission: leadData._id,
        Comment: CommentVAlue,
      }),
    );

    setloading(false);
  };

  const resAddSchdualdate = useSelector(
    (state) => state.AllSchedual_Commission_Dates.Add_Payment_Date,
  );

  useEffect(() => {
    if (loading === false) {
      if (resAddSchdualdate && resAddSchdualdate.status === 201) {
        Notify('success', 'Date Added Successfully', 'Success');

        // 🧼 تفريغ القيم بعد النجاح
        setSelectedDate(null);
        setmoneyofpayment('');
        setCommentVAlue('');
        setShowDatePicker(false); // اختياري لو عايز تقفل الـ Date Picker بعد النجاح
      } else {
        Notify('error', 'Failed To Add Document', 'error');
      }
    }
  }, [loading]);

  return (
    <Container className="py-4 startpage">
      {/* Breadcrumb */}
      <div className="mb-3">
        <Link
          to="/LeadsForAccountant"
          style={{ textDecoration: 'none', color: '#0F7687', fontWeight: 'bold' }}
        >
          Home
        </Link>
        <KeyboardDoubleArrowRightIcon />
        <span style={{ fontWeight: 'bold', color: '#333' }}>
          {`Schedual Commission For Lead: ${leadData?.lead?.name || '...'}`}
        </span>
      </div>

      <hr />

      {/* Commission Info Card */}
      <Box
        sx={{ minWidth: 400 }}
        style={{
          color: mode === 'dark' ? '#90caf9' : '#0F7687',
          backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
        }}
      >
        <Card
          variant="outlined"
          sx={{ padding: 3, borderRadius: 2, boxShadow: 2 }}
          style={{
            color: mode === 'dark' ? '#90caf9' : '#0F7687',
            backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
          }}
        >
          <CardContent
            style={{
              color: mode === 'dark' ? '#90caf9' : '#0F7687',
              backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
            }}
          >
            <Typography variant="h6" sx={{ color: '#0F7687', fontWeight: 'bold', mb: 2 }}>
              💰 Commission Details
            </Typography>

            <Grid
              container
              spacing={3}
              style={{
                color: mode === 'dark' ? '#90caf9' : '#0F7687',
                backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
              }}
            >
              <Grid
                item
                xs={12}
                sm={6}
                md={3}
                style={{
                  color: mode === 'dark' ? '#90caf9' : '#0F7687',
                  backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
                }}
              >
                <Typography variant="subtitle2" color="text.secondary">
                  Commission Rate
                </Typography>
                <Typography
                  variant="body1"
                  style={{
                    color: mode === 'dark' ? '#90caf9' : '#0F7687',
                    backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
                  }}
                >
                  {leadData?.commissionRate} %
                </Typography>
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <Typography variant="subtitle2" color="text.secondary">
                  Commission Value
                </Typography>
                <Typography
                  variant="body1"
                  style={{
                    color: mode === 'dark' ? '#90caf9' : '#0F7687',
                    backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
                  }}
                >
                  {leadData?.commissionValue}
                </Typography>
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <Typography variant="subtitle2" color="text.secondary">
                  VAT Rate
                </Typography>
                <Typography
                  variant="body1"
                  style={{
                    color: mode === 'dark' ? '#90caf9' : '#0F7687',
                    backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
                  }}
                >
                  {leadData?.vatRate} %
                </Typography>
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <Typography variant="subtitle2" color="text.secondary">
                  VAT Value
                </Typography>
                <Typography
                  variant="body1"
                  style={{
                    color: mode === 'dark' ? '#90caf9' : '#0F7687',
                    backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
                  }}
                >
                  {leadData?.vatValue}
                </Typography>
              </Grid>
            </Grid>
          </CardContent>

          <CardActions sx={{ justifyContent: 'flex-start', mt: 2 }}>
            <Button variant="contained" onClick={() => setShowDatePicker((prev) => !prev)}>
              <AddIcon /> Add Payment Date
            </Button>

            <Link to={`/ShowAllPaymentsDates/${leadData?._id}`} style={{ textDecoration: 'none' }}>
              <Button variant="contained" color="success">
                📅 Show All Payment Dates
              </Button>
            </Link>
          </CardActions>
        </Card>

        {showDatePicker && (
          <div
            variant="outlined"
            className="my-2"
            sx={{ paddingTop: 1, paddingLeft: 3, borderRadius: 2, boxShadow: 2 }}
          >
            <div>
              <Typography variant="h6" sx={{ color: '#0F7687', fontWeight: 'bold', mb: 2 }}>
                <div className="mt-2" style={{ maxWidth: 300 }}>
                  <label style={{ fontWeight: 'bold' }}>Select Payment Date:</label>
                  <Datetime
                    value={selectedDate}
                    onChange={handleDateChange}
                    inputProps={{
                      placeholder: 'Pick a date & time',
                      className: 'form-control mt-2',
                    }}
                  />
                </div>
              </Typography>

              <TextField
                value={moneyofpayment}
                onChange={onpaymentmoneyvaluechange}
                type="number"
                label="Money Payment"
                color="secondary"
                focused
                className="w-100 my-2"
              />
              <TextField
                value={CommentVAlue}
                onChange={OnCommentChange}
                type="text"
                label="Comment And Notes"
                color="secondary"
                focused
                className="w-100 my-2"
              />

              <Button variant="contained" onClick={AddNewPaymentdate}>
                <EventNoteIcon /> Add Date
              </Button>
            </div>
          </div>
        )}
      </Box>
    </Container>
  );
};
